import config from 'constants/config'

import request from 'api/requestUtils'
import qs from 'qs'
import { isEnabledForFeature } from 'lib/config/featureFlagUtils'
import { arrayToObject } from 'lib/array/arrayUtils'
import { isolatePhoneNumber } from 'lib/format/formatPhoneNumber'
import { isAgentHubEnabled } from 'agentHub/selectors/isAgentHubEnabled'

function mapContact(contact: any = {}): App.GeoContact {
  return {
    humanReadable: isolatePhoneNumber(contact.human_readable),
    number: contact.number,
  }
}

function mapContacts(contacts: Array<any> = []) {
  return arrayToObject(
    contacts,
    (contact) => {
      // response from API comes back as 'ultralux'
      if (contact.type === 'ultralux') {
        return 'ultraLux'
      }

      if (contact.type === 'luxLoyalty') {
        return 'loyalty'
      }

      return contact.type
    },
    (contact) => ({
      local: mapContact(contact.local),
      international: mapContact(contact.international),
      defaultContact: mapContact(contact[contact.default]),
    }),
  )
}

function mapGeoData(
  region: any,
): Partial<App.GeoState> {
  const geoData: Partial<App.GeoState> = {
    partnership: undefined,
    currentRegionHasFlights: !!(
      region.has_flights &&
      config.FLIGHT_ENABLED &&
      (!isAgentHubEnabled || isFlightsEnabledForAgentHub(region))
    ),
    currentRegionName: region.name,
    currentRegionCode: region.code,
    currentCurrency: region.currency_code,
    currentContact: {
      local: mapContact(region.phone.local),
      international: mapContact(region.phone.international),
      default: region.phone.default,
      defaultContact: mapContact(region.phone[region.phone.default]),
      autoVerification: false,
    },
    insuranceProductName: region.insurance_product_name,
    isStrikethroughPricingRegion: isEnabledForFeature(config.STRIKETHROUGH_PRICING_REGIONS, region.code),
    contacts: {
      ...mapContacts(region.contacts) as App.GeoContactsTypes,
    },
  }

  return geoData
}

function getRegionData(regionCode: string) {
  const query = qs.stringify({ no_detect: true })
  return request.get<App.ApiResponse<{ regions: Array<any> }>>(`/regions?${query}`).then(response => {
    return response.result.regions.find(val => val.code === regionCode)
  })
}

export async function getGeoData(
  regionCode: string,
): Promise<Partial<App.GeoState>> {
  const regionData = await getRegionData(regionCode)

  return mapGeoData(regionData)
}

function isFlightsEnabledForAgentHub(region: any) {
  return isAgentHubEnabled && isEnabledForFeature(config.STANDALONE_FLIGHT_REGIONS, region.code)
}
